import SetupHikTriggerAlarmSmsModal from './setup-hik-trigger-alarm-sms-modal.vue'
export default SetupHikTriggerAlarmSmsModal
